const anomalies = {
    title: '不審行為一覧',
    severity: '重要度',
    status: '状態',
    type: '種別',
    path: 'パス',
    resolved: '解決済',
    unresolved: '未解決',
    markResolved: '解決済みにする',
    noMatchingAnomalies: '該当する不審行為はありません',
    resolveDialogTitle: '不審行為を解決にする',
    resolveNote: '解決メモ (任意)',
    totalCount: '合計 {{total}} 件',
    fetchFailed: '不審行為一覧の取得に失敗: {{message}}',
    resolveFailed: '解決マークに失敗: {{message}}',
    severityValues: {
      low: 'low',
      medium: 'medium',
      high: 'high',
      critical: 'critical',
    },
  };

export default anomalies;
